// extracted by mini-css-extract-plugin
module.exports = {"imgwrap":"Ux0Nf","content":"qnlwE"};